import { CardTypeEnum } from './types'

interface CampaignDates {
  closeDate?: number
  startDate?: number
}

export const getCorrectTimestamp = (state: CardTypeEnum, campaignDates?: CampaignDates) => {
  switch (state) {
    case CardTypeEnum.FINISHED:
    case CardTypeEnum.ONGOING: {
      return campaignDates?.closeDate
    }
    case CardTypeEnum.UPCOMING: {
      return campaignDates?.startDate
    }
    default:
      return null
  }
}

export const getClickableLink = (state?: CardTypeEnum, slug?: string, embedded?: boolean, fromNewApi?: boolean) => {
  if (!state) {
    return null
  }

  const route = fromNewApi ? 'investeringstilbud' : 'kampanje'

  if ([CardTypeEnum.FINISHED, CardTypeEnum.UPCOMING, CardTypeEnum.ONGOING].includes(state)) {
    if (embedded) {
      return `${window.location.origin}/${route}/${slug}`
    }
    return `/${route}/${slug}`
  }
  return null
}

export type StickerTypeInvestmentOfferData = {
  state: CardTypeEnum
  startDate?: Date
  maxShares: number
  reservedShares?: number
}

export const getStickerType = (
  investmentOfferData: StickerTypeInvestmentOfferData,
  visitorSettings?: { approvedForPreorder?: boolean },
  openForPreorder?: boolean,
) => {
  const isFull = investmentOfferData.maxShares === investmentOfferData.reservedShares

  if (isFull) {
    return 'full'
  }

  if (visitorSettings && openForPreorder && visitorSettings.approvedForPreorder) {
    return 'invite'
  }
}
